import { render } from "./AlertBannersReact.vue?vue&type=template&id=027f1a25"
import script from "./AlertBannersReact.vue?vue&type=script&lang=js"
export * from "./AlertBannersReact.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__